<template>
    <div class="flex flex-col max-h-60 w-full">
        <div class="-my-2 overflow-x-none sm:-mx-6 lg:-mx-8">
            <div class="py-2 align-middle inline-block min-w-full sm:px-6 lg:px-8">
                <div class="shadow overflow-hidden border-b border-gray-200 dark:border-gray-700 sm:rounded-lg">
                    <table class="w-full divide-y divide-gray-700">
                        <thead class="bg-gray-50 dark:bg-black">
                            <tr>
                                <th v-for="header, i in headers"  :key="i" scope="col" class="px-6 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-300 uppercase tracking-wider">
                                    {{beautifyName(header)}}
                                </th>
                            </tr>
                        </thead>
                        <tbody class="bg-white dark:bg-gray-800 divide-y divide-gray-200 max-h-56">
                            <tr v-if="data.length === 0" class="w-full" >
                                <td colspan="5" class=" text-center h-16">Esta loja não possui registro de contatos prévios</td>

                            </tr>
                            <tr v-else v-for="d, i in data" :key="i" class=" border-gray-600">
                                <td v-for="header, j in headers" :key="j" class="px-6 py-4 whitespace-nowrap">
                                    <!-- PESQUISADOR -->
                                    <template v-if="header === 'pesquisador'">
                                        <div class="flex items-center">
                                            <div class="flex-shrink-0 h-10 w-10">
                                                <img v-if="d[header]['avatar']" class="rounded-full " :src="d[header]['avatar']" alt="">
                                                <span v-else class="h-full w-full flex"><p class="m-auto text-2xl">{{d[header]['nome'][0]}}{{d[header]['nome'].split(' ')[1][0]}}</p></span>
                                            </div>
                                            <div class="ml-4">
                                                <div class="text-sm font-medium text-gray-900 dark:text-gray-300">
                                                    {{d[header]['nome']}}
                                                </div>
                                            </div>
                                        </div>
                                    </template>
                                    
                                    <!-- ANO/MES -->
                                    <template v-else-if="header === 'ano_mes'">
                                        <p class="text-sm text-gray-800 dark:text-gray-400">{{d[header] ? d[header].slice(0,4)+'/'+d[header].slice(4,6) : '—'}}</p>
                                    </template>

                                    <!-- DEFAULT -->
                                    <template v-else>
                                        <div class="text-sm text-gray-800 dark:text-gray-400">{{d[header] ? beautifyCell(d[header], header) : `Sem ${beautifyName(header).toLowerCase()}`}}</div>
                                    </template>
                                </td>
                            </tr>

                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { dateTimeFormat } from '../../mixins/mask.js'
export default {
    name: 'Table',
    props: ['headers', 'data'],
    setup () {
        const dataMask = dateTimeFormat

        const beautifyCell = (value, header) => {
            switch (header) {
            case 'data':
                return dataMask(value)

            default:
                return value
            }
        }

        const beautifyName = name => {
            switch (name) {
            case 'nome_contato_loja':
                return 'Nome do Contato da Loja'
            case 'status_descricao':
                return 'Status'
            case 'observacao':
                return 'Observação'
            case 'ano_mes':
                return 'Ano/Mês'
            default:
                return name
            }
        }

        return {
            dataMask,
            beautifyCell,
            beautifyName
        }
    }

}
</script>
